import {inject, Injectable} from '@angular/core';
import {ApolloService} from './apollo.service';
import {IsZipcodeDeliverableResponse, Query} from '../interfaces/generated/graphql';
import {captureException} from '@sentry/angular';

@Injectable({
  providedIn: 'root'
})
export class DeliveryService {
  private apollo = inject(ApolloService);

  /**
   * Check if delivery is available for a given postcode
   * @param postcode - The postcode to check
   * @param countryCode - Optional country code (defaults to SE)
   * @returns Promise with delivery availability response
   */
  async isPostcodeDeliverable(
    postcode: string,
    countryCode?: string
  ): Promise<IsZipcodeDeliverableResponse | undefined> {
    try {
      const result = await this.apollo.queryPromise<Query>({
        queryName: 'isPostcodeDeliverableQuery',
        variables: {
          postcode,
          countryCode
        }
      });
      return result.data.isPostcodeDeliverable || undefined;
    } catch (error) {
      const errorObj = new Error(`Failed to check postcode deliverability: ${error}`);
      errorObj.name = 'DeliveryService.isPostcodeDeliverable';
      captureException(errorObj);
      return undefined;
    }
  }
}
